/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  SimpleAttachResponse,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SimpleAttachResponseFromJSON,
    SimpleAttachResponseToJSON,
} from '../models/index';

export interface SimpleAttachEmailRequest {
    claimNumber: string;
    file: Blob;
}

/**
 * 
 */
export class EmailApi extends runtime.BaseAPI {

    /**
     * Feasibility spike: places the original message supplied by the add-in into the McLarens One ingestion mailbox with the claim number appended to the subject.
     */
    async simpleAttachEmailRaw(requestParameters: SimpleAttachEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SimpleAttachResponse>> {
        if (requestParameters['claimNumber'] == null) {
            throw new runtime.RequiredError(
                'claimNumber',
                'Required parameter "claimNumber" was null or undefined when calling simpleAttachEmail().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling simpleAttachEmail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request({
            path: `/api/claims/{claimNumber}/simple-attach`.replace(`{${"claimNumber"}}`, encodeURIComponent(String(requestParameters['claimNumber']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SimpleAttachResponseFromJSON(jsonValue));
    }

    /**
     * Feasibility spike: places the original message supplied by the add-in into the McLarens One ingestion mailbox with the claim number appended to the subject.
     */
    async simpleAttachEmail(requestParameters: SimpleAttachEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SimpleAttachResponse> {
        const response = await this.simpleAttachEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
